document.addEventListener('DOMContentLoaded', function() {

(function loadHeic2Any() {
  if (!window.heic2any) {
    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js";
    script.onload = () => console.log("✅ heic2any ready for HEIC conversion");
    document.head.appendChild(script);
  }
})();

const maxImages = 3;
let uploadedImages = [];
const photoInput = document.getElementById('photoInput');
const dragDropText = document.getElementById('dragDropText');
const imagePreviewGrid = document.getElementById('imagePreviewGrid');
const toStep2 = document.getElementById('toStep2');

console.log('photoInput:', photoInput);
console.log('dragDropText:', dragDropText);
console.log('imagePreviewGrid:', imagePreviewGrid);
console.log('toStep2:', toStep2);

photoInput.onchange = function(e) { 
  console.log('📸 Files selected:', e.target.files);
  handleFiles(Array.from(e.target.files)); 
};
dragDropText.ondragover = function(e) { e.preventDefault(); dragDropText.classList.add('dragover'); };
dragDropText.ondragleave = function(e) { e.preventDefault(); dragDropText.classList.remove('dragover'); };
dragDropText.ondrop = function(e) {
  e.preventDefault();
  dragDropText.classList.remove('dragover');
  handleFiles(Array.from(e.dataTransfer.files));
};

async function handleFiles(files) {
  console.log('handleFiles called with:', files.length, 'files');
  const availableSlots = maxImages - uploadedImages.length;
  const filesToAdd = files.slice(0, availableSlots);
  console.log('filesToAdd:', filesToAdd.length);

  for (const file of filesToAdd) {
    let workingFile = file;

    // HEIC → JPG conversion
    if (file.type === "image/heic" || file.type === "image/heif") {
      try {
        const convertedBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.9
        });
        workingFile = new File(
          [convertedBlob],
          file.name.replace(/\.[^/.]+$/, "") + ".jpg",
          { type: "image/jpeg" }
        );
      } catch (err) {
        console.error("HEIC conversion error:", err);
        alert(`Could not convert HEIC image (${file.name}). Please upload JPG/PNG instead.`);
        continue;
      }
    }

    try {
      const options = {
        maxSizeMB: 1.5,
        maxWidthOrHeight: 2000
      };
      const compressedFile = await imageCompression(workingFile, options);
      console.log('✅ Compressed:', compressedFile.name);
      uploadedImages.push(compressedFile);
    } catch (err) {
      console.error("Compression error:", err);
      alert(`Could not compress image (${file.name}). Try a smaller file.`);
    }
  }
  renderImagePreviews();
}
function renderImagePreviews() {
  console.log('renderImagePreviews called, images:', uploadedImages.length);
  imagePreviewGrid.innerHTML = '';
  uploadedImages.forEach((file, idx) => {
    const reader = new FileReader();
    reader.onload = function(e) {
      const div = document.createElement('div');
      div.className = 'preview-thumb';
      div.innerHTML = `<img src="${e.target.result}"/><button type='button' class='remove-img' data-idx='${idx}'>&times;</button>`;
      imagePreviewGrid.appendChild(div);
      div.querySelector('button').onclick = function() {
        uploadedImages.splice(idx, 1);
        renderImagePreviews();
      };
    };
    reader.readAsDataURL(file);
  });
  toStep2.disabled = uploadedImages.length === 0;
}

toStep2.onclick = function() {
  document.getElementById('step1').style.display = 'none';
  document.getElementById('step2').style.display = 'block';
};

// Step 2 Navigation & Validation Logic
const contactName = document.getElementById('contactName');
const contactEmail = document.getElementById('contactEmail');
const contactPhone = document.getElementById('contactPhone');
const toStep3 = document.getElementById('toStep3');
const step2 = document.getElementById('step2');
const step3 = document.getElementById('step3');
const backToStep1 = document.getElementById('backToStep1');

toStep3.disabled = false;

function showStep2Error(text) {
  let msg = document.getElementById('step2ValidationMsg');
  if (!msg) {
    msg = document.createElement('div');
    msg.id = 'step2ValidationMsg';
    msg.style.cssText = 'color:#FF4444;font-weight:600;margin-top:12px;font-size:15px;transition:opacity 0.5s;';
    const stepNav = toStep3.parentNode;
    stepNav.parentNode.insertBefore(msg, stepNav.nextSibling);
  }
  msg.textContent = text;
  msg.style.opacity = '1';
}

toStep3.onclick = async function() {
  const nameVal = contactName.value.trim();
  const emailVal = contactEmail.value.trim();
  const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal);

  if (!nameVal && !emailVal) {
    showStep2Error('Add your name and email mate 👆');
    return;
  }
  if (!nameVal) {
    showStep2Error('Add your name mate 👆');
    return;
  }
  if (!emailVal || !emailValid) {
    showStep2Error("That email doesn't look right mate 👆");
    return;
  }
  // Check TLD is a recognised one (.com, .com.au, .net, .org etc.)
  const validTLD = /\.(ai|com|com\.au|net|net\.au|org|org\.au|edu|gov|io|co|me|app)$/i.test(emailVal);
  if (!validTLD) {
    showStep2Error("That email ending doesn't look right — check after the dot 👆");
    return;
  }
  // Catch common provider misspellings
  const domainTypos = {
    gnail: 'gmail', gmai: 'gmail', gamil: 'gmail', gmial: 'gmail', gmali: 'gmail',
    hotmal: 'hotmail', hotmai: 'hotmail', homail: 'hotmail', hotmial: 'hotmail',
    yahooo: 'yahoo', yaho: 'yahoo', yhoo: 'yahoo',
    outlok: 'outlook', outloo: 'outlook', otulook: 'outlook'
  };
  const domainMatch = emailVal.match(/@([^.]+)\./);
  if (domainMatch) {
    const domain = domainMatch[1].toLowerCase();
    if (domainTypos[domain]) {
      showStep2Error(`Did you mean @${domainTypos[domain]}.com? 👆`);
      return;
    }
  }
  // Catch gmail.com.au and gmail.co
  if (/^[^\s@]+@gmail\.(com\.au|co)$/i.test(emailVal)) {
    showStep2Error("Did you mean @gmail.com? Double check your email mate 👆");
    return;
  }
  // Catch .con, .cpm, .ocm etc.
  if (/\.(con|cpm|ocm|cmo|ney|ogr|met|nte)$/i.test(emailVal)) {
    const typo = emailVal.match(/\.([a-z]+)$/i)[1];
    const fix = typo === 'con' ? 'com' : typo === 'cpm' ? 'com' : typo === 'ney' ? 'net' : typo === 'ogr' ? 'org' : 'com';
    showStep2Error(`Did you mean .${fix}? Double check your email mate 👆`);
    return;
  }

  step2.style.display = 'none';
  step3.style.display = 'block';
};

backToStep1.onclick = function() {
  step2.style.display = 'none';
  document.getElementById('step1').style.display = 'block';
};

// --- Step 3 Navigation, Consent, Submission ---
const backToStep2 = document.getElementById('backToStep2');
const submitOrder = document.getElementById('submitOrder');
const consent1 = document.getElementById('consent1');
const consent2 = document.getElementById('consent2');
const reviewImageCount = document.getElementById('reviewImageCount');
const reviewContact = document.getElementById('reviewContact');
const submissionStatus = document.getElementById('submissionStatus');

// Show summary when entering step 3 (call this when navigating to step 3!)
function updateReviewSummary() {
  reviewImageCount.textContent = `${uploadedImages.length} image${uploadedImages.length === 1 ? '' : 's'} uploaded`;
  reviewContact.textContent = `${contactName.value} - ${contactEmail.value}`;
}

// Consent validation
function validateReviewStep() {
  submitOrder.disabled = !(consent1.checked && consent2.checked);
}
consent1.onchange = validateReviewStep;
consent2.onchange = validateReviewStep;

// Navigation
backToStep2.onclick = function() {
  step3.style.display = 'none';
  document.getElementById('step2').style.display = 'block';
};

step3.onsubmit = async function(e) {
  e.preventDefault();
  submitOrder.disabled = true;
  submissionStatus.textContent = "Submitting...";

  try {
    // Convert images to base64 and build a flat files array
    const files = await Promise.all(
      uploadedImages.map(file => new Promise((resolve, reject) => {
        if (!file) {
          reject("Invalid file in upload list");
          return;
        }
        const reader = new FileReader();
        reader.onload = () => resolve({
          name: file.name,
          mime: file.type,
          data: reader.result.split(',')[1] // base64 only, no data:... prefix
        });
        reader.onerror = (ev) => {
            console.error("FileReader error:", ev);
            reject(`File load failed: ${file.name}. Try re-uploading as JPG/PNG.`);
        };
        try {
          reader.readAsDataURL(file);
        } catch (e) {
          console.error("FileReader threw before onerror:", e);
          reject(`❌ Immediate FileReader failure: ${file.name}. Reason: ${e.message || e.name}`);
        }
      }))
    );

    // Build the JSON payload
    const payload = {
      timestamp: new Date().toISOString(),
      contactName: contactName.value,
      contactEmail: contactEmail.value,
      contactPhone: contactPhone.value,
      consent: true,
      redirectAgreement: true,
      source: "submit-ya-rig-form",
      imageCount: files.length,
      files: files
    };

    // Send to Make.com webhook
    const WEBHOOK_URL = "https://hook.eu2.make.com/cfm83x7vux9knxc0gvtmlj4oncioujoo"; // your webhook
    const response = await fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    const text = await response.text();
    if (!response.ok) {
      if (response.status === 413) {
        submissionStatus.innerHTML = `<span style="color:red;">
          ❌ Error: Payload too large.<br/>
          Try uploading fewer or smaller images (current count: ${files.length}).
        </span>`;
      } else {
        submissionStatus.innerHTML = `<span style="color:red;">
          ❌ Error submitting! (Status ${response.status})<br/>${text}
        </span>`;
      }
      submitOrder.disabled = false;
      return;
    }
    
    // Success
    submissionStatus.innerHTML = '<span style="color:#FFD700; font-weight:bold;">Order Submitted! Check your email ya dog.</span>';
    setTimeout(() => window.location.reload(), 2100);

  } catch (err) {
    submissionStatus.innerHTML = `<span style="color:red;">Error: ${err}</span>`;
    console.error("Form submission error:", err);
    submitOrder.disabled = false;
  }
};

});
